import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";

import router from "./router";
import store from "./store";

// importing vuetify
import '@mdi/font/css/materialdesignicons.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import vuetify from "./plugins/vuetify"

import VueTelInputVuetify from 'vue-tel-input-vuetify/lib';
Vue.use(VueTelInputVuetify, {vuetify});

import Logo from '@/components/main/logo'
Vue.component('logo', Logo)

import InfoTooltip from './components/default/info-tooltip'
Vue.component('info-tooltip', InfoTooltip)

import ActionDialog from '@/components/default/dialogs/action-dialog'
Vue.component('action-dialog', ActionDialog)

import DatetimePicker from 'vuetify-datetime-picker'
Vue.use(DatetimePicker);

window.apiUrl = process.env.VUE_APP_API_URL
import axios from 'axios'
axios.defaults.baseURL = window.apiUrl;
window.axios = axios

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
